import { render } from "./UploadedFilePreview.vue?vue&type=template&id=32a644ed&lang=pug"
import script from "./UploadedFilePreview.vue?vue&type=script&lang=js"
export * from "./UploadedFilePreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__